export const PREVIOUS_ADMIN_ADDINS_KEY = 'previousAdminAddins';
